/**
 * Properties and methods relating to the panama user - Previously MMF.Urls
 */

mmf_modules.define('utils/urls',[
    'context_vars/utils/urls',
    'utils/utils'
], function (
    context,
    utils
) {
    'use strict';

     var Urls = utils.extend(true, {}, context);

     return Urls;
});

